import React, { forwardRef } from "react";
import { MessageBox } from "reusableComponents";
import getFilteredDispositionTypes from "helpers/getSpaceDispositionTypes";
import styles from "./styles.module.scss";

const DispositionTypes = forwardRef(({ space, formData, setFormData, errors, capacity, t }, ref) => {
  const dispositionTypes = getFilteredDispositionTypes(space, t, capacity);

  const handleDispositionChange = (dispositionKey, disabled) => {
    if (!disabled) {
      setFormData({ 
        ...formData, 
        disposition_type: formData.disposition_type === dispositionKey ? null : dispositionKey 
      });
    }
  };

  if (!dispositionTypes?.length) return null;

  return (
    <div 
      ref={ref} 
      className={styles.dispositionSection}
      id="disposition-section"
    >
      <div className={styles.sectionHeader}>
        <h2>{t("booking.fullBookingPage.disposition.title")}</h2>
        <p className={styles.subtitle}>
          {t("booking.fullBookingPage.disposition.subtitle")}
        </p>
      </div>
      
      <div className={styles.dispositionGrid}>
        {dispositionTypes.map(({ key, count, Icon, name, disabled }) => {
          const isSelected = formData.disposition_type === key;
          return (
            <div
              key={key}
              className={`${styles.dispositionCard} ${disabled ? styles.disabled : ""} ${isSelected ? styles.selected : ""}`}
              onClick={() => handleDispositionChange(key, disabled)}
            >
              <div className={styles.dispositionIcon}>
                <Icon 
                  className={styles.icon} 
                />
              </div>
              <div className={styles.dispositionInfo}>
                <div className={styles.dispositionName}>{name}</div>
                <div className={styles.dispositionCapacity}>
                  {t("booking.fullBookingPage.disposition.max")} {count} {t("booking.fullBookingPage.disposition.people")}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      {errors?.disposition_type && (
        <MessageBox type="error" message={errors.disposition_type} />
      )}
    </div>
  );
});

DispositionTypes.displayName = 'DispositionTypes';

export default DispositionTypes;
